import { useState, useEffect, useContext } from 'react'
import Step1 from '../../common/components/Step1'
import axios from "axios"
import UserContext from '../../common/helpers/userContext'
import MultiStepForm from '../../common/components/MultiStepForm'
import newReceiver from '../../common/helpers/newReceiver'
import { isDemoMode, getApiBaseUrl } from '../../common/config/env'

function SendingMoney() {
  const [sendingMoney, setSendingMoney] = useState({
    //DEL CLIENTE
    clientName: "",
    email: "",
    amount: 1,
    paymentType: "Dolar Américano",
    creditCard: "",
    //DEL DESTINATARIO
    receiverName: "",
    carnet: "",
    phone: "",
    receiverCard: "",
    //Direccion Exacta
    province: "",
    township: "",
    distribution: "",
    principalStreet: "",
    middleStreets: "",
    buildingNumber: "",
    apartment: "",
    //stripe Info
    stripeProductName: "",
    stripeProductPrice: 0,
  })

  const [selectedReceiver, setSelectedReceiver] = useState("")
  const [registeredReceivers, setRegisteredReceivers] = useState([])
  const [usableCurrency, setUsableCurrency] = useState([])
  const { clientData, setRouteToNavigate, setActualStep } = useContext(UserContext)

  useEffect(()=>{
    setActualStep(0)
    const accessToken = localStorage.getItem("accessToken")

    setRouteToNavigate("/shop/sendingMoney")

    setSendingMoney( (prevSendingMoney) => ({...prevSendingMoney,
      email: clientData.email,
      clientName: clientData.clientName,
      }))

    if (isDemoMode()) {
      // Mock the API call for demo mode
      console.log("[DEBUG MOCK SERVICE] Mocking getReceivers");
      const mockUser = {
        email: clientData.email,
        clientName: clientData.clientName,
        receivers: [
          { id: "1", name: "Mock Receiver 1", carnet: "123456789", phone: "555-1111", receiverCard: "1111-2222-3333-4444", province: "Mock Province 1", township: "Mock Township 1", distribution: "Mock Distribution 1", principalStreet: "Mock Street 1", middleStreets: "Mock Middle Street 1", buildingNumber: "1A", apartment: "apt 1" },
          { id: "2", name: "Mock Receiver 2", carnet: "987654321", phone: "555-2222", receiverCard: "5555-6666-7777-8888", province: "Mock Province 2", township: "Mock Township 2", distribution: "Mock Distribution 2", principalStreet: "Mock Street 2", middleStreets: "Mock Middle Street 2", buildingNumber: "2B", apartment: "apt 2" },
        ],
      };
      const mockCurrency = [
        { nameOfTheCurrency: "Dolar Américano", exchangeRateValuePerDollar: 1, intermediateValueToChangeRate: 100, underIntermediateValueChargeToSum: 5, overIntermediateValueChargeInPercentage: 2 },
        { nameOfTheCurrency: "Euro", exchangeRateValuePerDollar: 1.1, intermediateValueToChangeRate: 120, underIntermediateValueChargeToSum: 6, overIntermediateValueChargeInPercentage: 2.5 },
      ];

      setSendingMoney((prevSendingMoney) => ({
        ...prevSendingMoney,
        email: mockUser.email || "",
        clientName: mockUser.clientName || "",
      }));
      setUsableCurrency(mockCurrency);
      setRegisteredReceivers([newReceiver, ...mockUser.receivers]);
      return; 
    }

    if( accessToken )
    axios.post(getApiBaseUrl() + "/buys/getReceivers",clientData,
    {headers: {'Authorization': 'Bearer '+ accessToken}})
    .then(e => {
      const user = e.data.user;
      const currency = e.data.currency;

      setSendingMoney( (prevSendingMoney) =>  ({
          ...prevSendingMoney,
          email: user.email || "",
          clientName: user.clientName || ""}))

      setUsableCurrency(currency)
      setRegisteredReceivers([newReceiver,...user.receivers])
    })
    .catch((e) => console.log(e))

  },[clientData, setActualStep, setRouteToNavigate])

  return (
    <>
      <div
       className='shopContainer flex flex-column justify-center align-center'>
        <MultiStepForm
          route={"/buys/sendingMoney"}
          DTO={sendingMoney}
          setDTO={setSendingMoney}
          usableCurrency={usableCurrency}
        >
            <Step1 
              usableCurrency={usableCurrency}
              registeredReceivers={registeredReceivers}
              DTO={sendingMoney}
              setDTO={setSendingMoney}
              selectedReceiver={selectedReceiver}
              setSelectedReceiver={setSelectedReceiver}
            />
        </MultiStepForm>
      </div>
    </>
  )
}

export default SendingMoney;